var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fdfdfd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.407 2.406)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.236,0C2.873,0,0,.508,0,2.545S2.854,5.109,6.236,5.109c3.363,0,6.236-.509,6.236-2.545S9.618,0,6.236,0Z",
    transform: "translate(0 10.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4,7.994A4,4,0,1,0,0,4,3.983,3.983,0,0,0,4,7.994Z",
    transform: "translate(2.239)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.5,0V3.509",
    transform: "translate(13.897 5.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.579.5H0",
    transform: "translate(12.608 6.434)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.54c9164ac90dd3bbd8233bcd393a7a8a.svg";
export { ForwardRef as ReactComponent };